import styled from 'styled-components';

// Styled Components
import {
  TextCell,
  Tr,
  TableContainer,
  Container,
  FiltersContainer,
} from '../components/MainStyledComponents';
import { ArrowBottom } from '../../../../assets/icons/ArrowBottom';

// types
import { ArrowBottomStyledProps, ShowFiltersButtonProps } from './types';
import { ContainersLoadingProps } from '../InputRadioArrowTable/types';

export const ContainerStyled = styled(Container)`
  position: relative;
`;

export const ContainerLoader = styled.div`
  position: absolute;
  top: 30%;
  left: 50%;
  z-index: 1;
`;

export const FiltersWithLoadingStyled = styled(
  FiltersContainer
)<ContainersLoadingProps>`
  opacity: ${(props) => (props.isLoading ? 0.6 : 1)};
`;

export const TableContainerStyled = styled(
  TableContainer
)<ContainersLoadingProps>`
  opacity: ${(props) => (props.isLoading ? 0.6 : 1)};
`;

export const TrStyled = styled(Tr)`
  background-color: ${(props) => props.checked && props.theme.colors.lightRed};
`;
export const SubContainerHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ShowFiltersButton = styled.button<ShowFiltersButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  height: 2.3rem;
  border-radius: 0.3rem;
  transition: background 300ms;
  background: ${(props) => (props.isBlack ? props.theme.colors.black : props.theme.colors.garnet)};
`;

export const ArrowBottomStyled = styled(ArrowBottom)<ArrowBottomStyledProps>`
  transition: transform 300ms;
  transform: ${({isRotate}) => (isRotate ? null : 'rotate(-90deg)')};
  width: 1rem;
  height: 1rem;
  path {
    fill: white;
  }
`;

export const TextCellStyled = styled(TextCell)`
  color: ${({ theme }) => theme.colors.black};
`;
